import React from 'react';
import EnvUtil from "../helpers/EnvUtil";

const shopify_settings = {
    dev: false,
    domain: '',
    shop_domain: '',
    store: '',
    api_url: '',
    api_key: '',
    static_content: '',
    version: '21100601',
};

class ShopifySetting {
    static shared = null;
    static getShared() {
        if ( ShopifySetting.shared == null ) {
            ShopifySetting.shared = new ShopifySetting();
        }
        return ShopifySetting.shared;
    }

    constructor() {
        let domain;
        let subdomain;
        let shop_url;
        // Prefer the real shop on URL
        /*if (EnvUtil.isLocal()) {
            shop_url = "https://" + process.env.REACT_APP_DEV_STORE + ".myshopify.com";
        } else {*/
            if (window.location.ancestorOrigins && window.location.ancestorOrigins.length) {
                shop_url = new URL(window.location.ancestorOrigins[0]).origin;
            } else {
                shop_url = new URLSearchParams(decodeURIComponent(window.location.search)).get('shop');
            }
            // Special case, shop_url is still null
            if (!shop_url && window.location.href) {
                shop_url = new URL(window.location.href).searchParams.get('shop');
            }
        //}

        if( shop_url.search("https://") !== 0 ) {
            shop_url = "https://" + shop_url;
        }
        shop_url = new URL(shop_url);
        domain = shop_url.hostname;
        subdomain = shop_url.hostname.split('.')[0];

        // handle subdomain for new domain admin.shopify.com/store/{store}
        if (subdomain === 'admin') {
            subdomain = this.getByNewDomain();
        }
        this.domain = subdomain + ".myshopify.com"; // It's still the same when moving to a new domain
        this.shop_domain = subdomain+".myshopify.com"; // // It's still the same when moving to a new domain
        this.store = subdomain;

        this.dev = subdomain === process.env.REACT_APP_DEV_STORE || subdomain === 'kbugstore' || EnvUtil.isLocal();

        this.api_url = shopify_settings.api_url;
        if( !this.api_url ) {
            this.api_url = this.dev? process.env.REACT_APP_URL_DEV_API:process.env.REACT_APP_URL_API;
        }

        this.api_key = shopify_settings.api_key;
        if( !this.api_key ) {
            this.api_key = this.dev? process.env.REACT_APP_SHOPIFY_API_KEY_DEV : process.env.REACT_APP_SHOPIFY_API_KEY;
        }

        this.static_content = shopify_settings.static_content;
        if( !this.static_content ) {
            this.static_content = this.dev? process.env.REACT_APP_URL_DEV_STATIC_CONTENT:process.env.REACT_APP_URL_STATIC_CONTENT;
        }

        this.version = shopify_settings.version;
        if( !this.version ) {
            this.version = this.dev? process.env.REACT_APP_VERSION_DEV:process.env.REACT_APP_VERSION;
        }

        if(this.dev) {
            console.log("window.location:", window.location);
            console.log('shopUrl:', new URLSearchParams(decodeURIComponent(window.location.search)).get('shop'));
            console.log("domain:", domain, "store: ", this.store);
            // console.log("shopify_setting:", this);
        }
    }

    getByNewDomain = () => {
        // ?embedded=1&hmac=ca81809307d61e35fec2bd1ca6897b670234ae8e081431d6d934bd64e7b34d93&host=YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvbGgyLXN0b3Jl&locale=en&session=da9d1c00b63e5106b1d9eb071fccc64d00e4efc9ae40855e09e0c2411fc46dc9&shop=lh2-store.myshopify.com&timestamp=1673668217
        // shop param always return format {store}.myshopify.com
        const shop_url = new URL(window.location.href).searchParams.get('shop');
        return shop_url.split('.')[0];
    }
}

export default ShopifySetting;
